import { IQuery } from '../interfaces';
import { Filter } from '../models/filter';
import { AttendanceRouteHandler } from './AttendanceRouteHandler';
import { AttendanceDegreeTypeRouteHandler } from './AttendanceDegreeTypeRouteHandler';
import { ContinentRouteHandler } from './ContinentRouteHandler';
import { CountryAreaRouteHandler } from './CountryAreaRouteHandler';
import { CountryDegreeTypeRouteHandler } from './CountryDegreeTypeRouteHandler';
import { CountryAttendanceMbaRouteHandler } from './CountryAttendanceMbaRouteHandler';
import { CountryDurationRouteHandler } from './CountryDurationRouteHandler';
import { CountryEducationalFormRouteHandler } from './CountryEducationalFormRouteHandler';
import { CountryFormatRouteHandler } from './CountryFormatRouteHandler';
import { CountryRouteHandler } from './CountryRouteHandler';
import { CountryTuitionFeeRouteHandler } from './CountryTuitionFeeRouteHandler';
import { DisciplineContinentRouteHandler } from './DisciplineContinentRouteHandler';
import { DisciplineCountryAreaRouteHandler } from './DisciplineCountryAreaRouteHandler';
import { DisciplineCountryRouteHandler } from './DisciplineCountryRouteHandler';
import { DisciplineCountryDegreeTypeRouteHandler } from './DisciplineCountryDegreeTypeRouteHandler';
import { DisciplineDegreeTypeRouteHandler } from './DisciplineDegreeTypeRouteHandler';
import { DisciplineDeliveryMethodRouteHandler } from './DisciplineDeliveryMethodRouteHandler';
import { DisciplineDurationRouteHandler } from './DisciplineDurationRouteHandler';
import { DisciplineEducationalFormCountryRouteHandler } from './DisciplineEducationalFormCountryRouteHandler';
import { DisciplineEducationalFormRouteHandler } from './DisciplineEducationalFormRouteHandler';
import { DisciplineFormatRouteHandler } from './DisciplineFormatRouteHandler';
import { DisciplineRouteHandler } from './DisciplineRouteHandler';
import { DisciplineTuitionFeeDeliveryMethodRouteHandler } from './DisciplineTuitionFeeDeliveryMethodRouteHandler';
import { DisciplineTuitionFeeRouteHandler } from './DisciplineTuitionFeeRouteHandler';
import { PortalRouteHandler } from './PortalRouteHandler';
import { CountryAttendanceRouteHandler } from './CountryAttendanceRouteHandler';
import { SpecialProgrammesRouteHandler } from './SpecialProgrammesRouteHandler';
import { CountryDegreeTypeOneYearRouteHandler } from './CountryDegreeTypeOneYearRouteHandler';
import { TuitionFeeRouteHandler } from './TuitionFeeRouteHandler';
import { TuitionFeeContinentRouteHandler } from './TuitionFeeContinentRouteHandler';

class RoutingHelper {
	private portalRouteHandler = new PortalRouteHandler();
	private disciplineRouteHandler = new DisciplineRouteHandler();
	private disciplineDegreeTypeRouteHandler = new DisciplineDegreeTypeRouteHandler();
	private disciplineDurationRouteHandler = new DisciplineDurationRouteHandler();
	private disciplineEducationalFormRouteHandler = new DisciplineEducationalFormRouteHandler();
	private disciplineEducationalFormCountryRouteHandler = new DisciplineEducationalFormCountryRouteHandler();
	private disciplineFormatRouteHandler = new DisciplineFormatRouteHandler();
	private disciplineTuitionFeeRouteHandler = new DisciplineTuitionFeeRouteHandler();
	private disciplineTuitionFeeDeliveryMethodRouteHandler = new DisciplineTuitionFeeDeliveryMethodRouteHandler();
	private disciplineDeliveryMethodRouteHandler = new DisciplineDeliveryMethodRouteHandler();
	private countryFormatRouteHandler = new CountryFormatRouteHandler();
	private countryDegreeTypeOneYearRouteHandler = new CountryDegreeTypeOneYearRouteHandler();
	private countryDegreeTypeRouteHandler = new CountryDegreeTypeRouteHandler();
	private countryAttendanceMbaRouteHandler = new CountryAttendanceMbaRouteHandler();
	private countryAttendanceRouteHandler = new CountryAttendanceRouteHandler();
	private countryDurationRouteHandler = new CountryDurationRouteHandler();
	private countryEducationalFormRouteHandler = new CountryEducationalFormRouteHandler();
	private countryRouteHandler = new CountryRouteHandler();
	private countryTuitionFeeRouteHandler = new CountryTuitionFeeRouteHandler();
	private disciplineCountryRouteHandler = new DisciplineCountryRouteHandler();
	private disciplineCountryDegreeTypeRouteHandler = new DisciplineCountryDegreeTypeRouteHandler();
	private continentRouteHandler = new ContinentRouteHandler();
	private disciplineContinentRouteHandler = new DisciplineContinentRouteHandler();
	private countryAreaRouteHandler = new CountryAreaRouteHandler();
	private disciplineCountryAreaRouteHandler = new DisciplineCountryAreaRouteHandler();
	private attendanceRouteHandler = new AttendanceRouteHandler();
	private attendanceDegreeTypeRouteHandler = new AttendanceDegreeTypeRouteHandler();
	private specialProgrammesRouteHandler = new SpecialProgrammesRouteHandler();
	private tuitionFeeRouteHandler = new TuitionFeeRouteHandler();
	private tuitionFeeContinentRouteHandler = new TuitionFeeContinentRouteHandler();
	private handlers = [
		this.portalRouteHandler,
		this.disciplineRouteHandler,
		this.disciplineDegreeTypeRouteHandler,
		this.disciplineDurationRouteHandler,
		this.disciplineEducationalFormRouteHandler,
		this.disciplineEducationalFormCountryRouteHandler,
		this.disciplineFormatRouteHandler,
		this.disciplineTuitionFeeRouteHandler,
		this.disciplineTuitionFeeDeliveryMethodRouteHandler,
		this.disciplineDeliveryMethodRouteHandler,
		this.countryFormatRouteHandler,
		this.countryDegreeTypeOneYearRouteHandler,
		this.countryDegreeTypeRouteHandler,
		this.countryAttendanceMbaRouteHandler,
		this.countryAttendanceRouteHandler,
		this.countryDurationRouteHandler,
		this.countryEducationalFormRouteHandler,
		this.countryRouteHandler,
		this.countryTuitionFeeRouteHandler,
		this.disciplineCountryRouteHandler,
		this.disciplineCountryDegreeTypeRouteHandler,
		this.continentRouteHandler,
		this.disciplineContinentRouteHandler,
		this.countryAreaRouteHandler,
		this.disciplineCountryAreaRouteHandler,
		this.attendanceRouteHandler,
		this.attendanceDegreeTypeRouteHandler,
		this.specialProgrammesRouteHandler,
		this.tuitionFeeRouteHandler,
		this.tuitionFeeContinentRouteHandler
	];

	public constructor() {
		this.disciplineDegreeTypeRouteHandler.setNext(this.disciplineDurationRouteHandler);
		this.disciplineDurationRouteHandler.setNext(this.disciplineEducationalFormRouteHandler);
		this.disciplineEducationalFormRouteHandler.setNext(this.disciplineEducationalFormCountryRouteHandler);
		this.disciplineEducationalFormCountryRouteHandler.setNext(this.disciplineFormatRouteHandler);
		this.disciplineFormatRouteHandler.setNext(this.disciplineTuitionFeeRouteHandler);
		this.disciplineTuitionFeeRouteHandler.setNext(this.disciplineTuitionFeeDeliveryMethodRouteHandler);
		this.disciplineTuitionFeeDeliveryMethodRouteHandler.setNext(this.disciplineDeliveryMethodRouteHandler);
		this.disciplineDeliveryMethodRouteHandler.setNext(this.countryFormatRouteHandler);
		this.countryFormatRouteHandler.setNext(this.countryDegreeTypeOneYearRouteHandler);
		this.countryDegreeTypeOneYearRouteHandler.setNext(this.countryDegreeTypeRouteHandler);
		this.countryDegreeTypeRouteHandler.setNext(this.countryAttendanceMbaRouteHandler);
		this.countryAttendanceMbaRouteHandler.setNext(this.countryAttendanceRouteHandler);
		this.countryAttendanceRouteHandler.setNext(this.countryDurationRouteHandler);
		this.countryDurationRouteHandler.setNext(this.countryEducationalFormRouteHandler);
		this.countryEducationalFormRouteHandler.setNext(this.countryTuitionFeeRouteHandler);
		this.countryTuitionFeeRouteHandler.setNext(this.disciplineCountryRouteHandler);
		this.disciplineCountryRouteHandler.setNext(this.disciplineCountryDegreeTypeRouteHandler);
		this.disciplineCountryDegreeTypeRouteHandler.setNext(this.continentRouteHandler);
		this.continentRouteHandler.setNext(this.disciplineContinentRouteHandler);
		this.disciplineContinentRouteHandler.setNext(this.countryAreaRouteHandler);
		this.countryAreaRouteHandler.setNext(this.disciplineCountryAreaRouteHandler);
		this.disciplineCountryAreaRouteHandler.setNext(this.attendanceRouteHandler);
		this.attendanceRouteHandler.setNext(this.attendanceDegreeTypeRouteHandler);
		this.attendanceDegreeTypeRouteHandler.setNext(this.disciplineRouteHandler);
		this.disciplineRouteHandler.setNext(this.countryRouteHandler);
		this.countryRouteHandler.setNext(this.specialProgrammesRouteHandler);
		this.specialProgrammesRouteHandler.setNext(this.tuitionFeeRouteHandler);
		this.tuitionFeeRouteHandler.setNext(this.tuitionFeeContinentRouteHandler);
		this.tuitionFeeContinentRouteHandler.setNext(this.portalRouteHandler);
	}

	public async changeUrl(filters: Filter[], query: IQuery, pageNumber: number): Promise<void> {
		await this.disciplineDegreeTypeRouteHandler.handle(filters, query, pageNumber);
	}

	public async resolveToUrl(filters: Filter[], query: IQuery, pageNumber: number): Promise<string | undefined> {
		return await this.disciplineDegreeTypeRouteHandler.resolveToUrl(filters, query, pageNumber);
	}

	public canBePrettified(filters: Filter[], path: string): boolean {
		const handler = this.handlers.find((_) => _.canHandle(filters) && !(_ instanceof PortalRouteHandler));

		if (handler === undefined) {
			return false;
		}

		return Object.keys(handler.getPathParametersForFilters(filters)).length > this.getPathLength(path);
	}

	private getPathLength(path: string): number {
		return path.split('/').length - 1;
	}
}

export default new RoutingHelper();
